import axiosInstance from "@/api/axios-instance";
import { PaginatedPrescriptions } from "../types/prescription";

export async function getPrescriptions({
  page,
  search,
  status,
  document_type,
  tags,
  start_date,
  end_date,
  professional_id,
}: {
  page: number;
  search?: string;
  status?: string;
  document_type?: string;
  tags?: string;
  start_date?: string;
  end_date?: string;
  professional_id?: string;
}): Promise<PaginatedPrescriptions> {
  const params: any = { page };
  if (search) params.search = search;
  if (status) params.status = status;
  if (document_type) params.document_type = document_type;
  if (tags) params.tags = tags;
  if (start_date) params.start_date = start_date;
  if (end_date) params.end_date = end_date;
  if (professional_id) params.professional_id = professional_id;

  try {
    const response = await axiosInstance.get("/prescriptions", { params });

    if (!response.status.toString().startsWith("2")) {
      throw new Error("Failed to load prescriptions");
    }

    return response.data;
  } catch (error: any) {
    console.error("Error fetching prescriptions:", error);
    if (error.response) {
      throw new Error(
        error.response.data?.message || error.response.data?.error || "Failed to load prescriptions"
      );
    }
    throw error;
  }
}
